import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { selectCurrentBreadcrumbs } from 'src/features/layout/selectors/layoutSelectors';

export const AppBreadCrumbs: FC = () => {
  const items = useSelector(selectCurrentBreadcrumbs);
  const location = useLocation();

  if (items.length === 0 || location.pathname === '/home') {
    return <></>;
  }

  const breadcrumbItems = [
    {
      title: (
        <Link to={'/home'}>
          <HomeOutlined />
        </Link>
      ),
    },
    ...(typeof items !== 'string'
      ? items.map((item, index) => ({
          title:
            item.route && index !== items.length - 1 ? (
              <Link to={item.route ?? '/'}>{item.label}</Link>
            ) : (
              item.label
            ),
        }))
      : []),
  ];

  return (
    <>
      <Breadcrumb
        style={{ padding: '16px 32px 0px 80px' }}
        items={breadcrumbItems}
      />
    </>
  );
};
